import {
  Component,
  ChangeDetectionStrategy,
  InputSignal,
  input,
  Output,
  EventEmitter,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MessageDialogComponent } from '../../../message-dialog/message-dialog.component';
import { STATUS_CHANGE_DIALOG_DATA } from 'src/app/shared/constants';

@Component({
  selector: 'app-boolean-column',
  templateUrl: './boolean-column.component.html',
  styleUrls: ['./boolean-column.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BooleanColumnComponent {
  value: InputSignal<boolean> = input<boolean>();
  markable: InputSignal<boolean> = input<boolean>();

  @Output() valueChange = new EventEmitter<boolean>();

  constructor(private dialog: MatDialog) {}

  changeStatus(): void {
    if (this.markable()) {
      const dialogRef = this.dialog.open(MessageDialogComponent, STATUS_CHANGE_DIALOG_DATA);

      dialogRef.afterClosed().subscribe((confirmed) => {
        if (confirmed) {
          this.valueChange.emit(!this.value());
        }
      });
    }
  }
}
